import { createSelector } from 'reselect'
import { getShared } from './helpers'

export const getServerTimestamp = createSelector(
  [getShared],
  (shared): number => shared.serverTimestamp || Date.now()
)
